/**
 * Skeleton com shimmer effect (cinza animado) — substitui "Carregando..."
 * para reduzir percepção de erro/tela travada enquanto a API responde.
 */
export function SkeletonBox({ className = "" }) {
  return (
    <div
      className={`bg-zinc-900/60 rounded-xl overflow-hidden relative ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.04) 50%, rgba(255,255,255,0) 100%)",
        backgroundSize: "200% 100%",
        animation: "skeletonShimmer 1.4s ease-in-out infinite",
      }}
      aria-hidden="true"
    />
  );
}

export function SkeletonCDGrid({ count = 8 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="space-y-2">
          <SkeletonBox className="aspect-square" />
          <SkeletonBox className="h-4 w-3/4" />
          <SkeletonBox className="h-3 w-1/2" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonList({ count = 6 }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 bg-zinc-900/40 rounded-lg p-3">
          <SkeletonBox className="w-12 h-12 rounded-lg flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <SkeletonBox className="h-3 w-3/4" />
            <SkeletonBox className="h-2 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonPlaylistRow({ count = 5 }) {
  return (
    <div className="space-y-1">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="grid grid-cols-12 gap-3 px-3 sm:px-6 py-3">
          <SkeletonBox className="h-4 w-4 col-span-1 rounded" />
          <div className="col-span-11 sm:col-span-5 flex items-center gap-3">
            <SkeletonBox className="w-10 h-10 rounded-lg" />
            <div className="flex-1 space-y-2">
              <SkeletonBox className="h-3 w-3/4" />
              <SkeletonBox className="h-2 w-1/3" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
